const HelperFunctions = {
    install(Vue) {
        Vue.mailLogSend = 0
        Vue.filterImages = function (dataObject) {
            // return dataObject.formats !== undefined ? true : false
            if(dataObject.formats !== undefined){
                // if(dataObject.formats !== undefined && dataObject.formats.jpg.size800x600 !== undefined) Überprüfung sorgt für Endlosschleife
                return true;
            } else {
                return false;
            }
        }
        Vue.filterImagesInResultsArray = function (results) {
            var filteredResults = results;
            var length = filteredResults.length
            var i = 0;
            for(i; i <length; i++){
                if(Array.isArray(filteredResults[i].details.media.images)){
                    filteredResults[i].details.media.images = filteredResults[i].details.media.images.filter(Vue.filterImages);
                }
            }
            // filter(Vue.filterImages)
            return filteredResults;
        }
    }
}

export default HelperFunctions